import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { PlusIcon } from '@motorway/mw-highway-code';

import { PhotoTipsModal } from '../../PhotoTipsModal/PhotoTipsModal';
import { useImageManager } from '../hooks/useImageManager';
import { Input } from '../pages/uploadImageReducer.types';
import UploadDocumentsTextsDrftTexts from '../UploadDocumentsDRFT.texts.json';

import {
  UploadDocumentsTilesProps,
} from './UploadDocumentsSection.types';
import { UploadDocumentsTile } from './UploadDocumentsTile';

import styles from './UploadDocumentsSection.scss';

const UploadDocumentsTextsDRFT = new MDText(UploadDocumentsTextsDrftTexts);

export const UploadDocumentsTiles = ({
  pagesLimit,
}: UploadDocumentsTilesProps) => {
  const {
    addExtraPage,
    hasUploadedDocuments,
    kind,
    sections,
  } = useImageManager();

  const hasInputWithoutUpload = sections.inputs.some((input: Input) => !input.url);

  const addAnotherPage = sections.addAnotherPage && sections.inputs.length < pagesLimit && !hasInputWithoutUpload;

  return (
    <ul className={cx(
      styles.image_section,
      { [styles.image_section_showing_all_thumbnails]: hasUploadedDocuments },
    )}>
      {sections.inputs.map((input, index) => (
        <UploadDocumentsTile key={`${kind}-${index}`} id={`${kind}-${index}`} input={input} />
      ))}
      {addAnotherPage
        && <li>
          <button
            className={styles.addAnotherPageDrft}
            onClick={addExtraPage}
            type="button"
          >
            <div className={styles.contentDrft}>
              <PlusIcon />
              <p>{UploadDocumentsTextsDRFT.translate('placeHolder.addMore')}</p>
            </div>
          </button>
        </li>
      }
      <PhotoTipsModal hasUploadedDocuments={hasUploadedDocuments} />
    </ul>
  );
};
